import LoginTwoStepEmailStepEmailForm from './form';

export default function LoginTwoStepEmailStepEmail() {
  return <LoginTwoStepEmailStepEmailForm />;
}
